import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NccSantaTeresaPage from "@/pages/NccSantaTeresaPage";
import LocationLanding from "@/pages/LocationLanding";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/ncc-santa-teresa-gallura" element={<NccSantaTeresaPage />} />
            <Route path="/ncc-olbia" element={<LocationLanding />} />
            <Route path="/ncc-palau" element={<LocationLanding />} />
            <Route path="/ncc-cannigione" element={<LocationLanding />} />
            <Route path="/ncc-baja-sardinia" element={<LocationLanding />} />
            <Route path="/ncc-bonifacio" element={<LocationLanding />} />
            {/* Catch-all: any unknown route redirects to the homepage */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </I18nProvider>
    </div>
  );
}

export default App;
